import { motion } from "framer-motion";
import { Chapter, EASE, MaskedLine, Reveal } from "../components/motion";
import { config } from "../config/siteConfig";

const Frameworks = () => (
  <section
    id="frameworks"
    data-testid="frameworks-section"
    className="bg-white text-[#08162B] py-24 lg:py-36"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Chapter index="04" label="Frameworks From The Book" />

      <h2 className="mt-10 font-display tracking-[0.02em] leading-[1] text-[clamp(2.4rem,6vw,5rem)]">
        <MaskedLine delay={0.1}>THIS ISN'T THEORY.</MaskedLine>
      </h2>
      <p className="mt-4 font-sans font-extrabold uppercase tracking-tight text-xl sm:text-3xl text-[#08162B]/40 max-w-3xl">
        <MaskedLine delay={0.25}>THESE ARE FRAMEWORKS YOU CAN ACTUALLY USE.</MaskedLine>
      </p>

      <div className="mt-16 grid md:grid-cols-2 xl:grid-cols-4 gap-5">
        {config.frameworks.map((fw, i) => (
          <motion.article
            key={fw.name}
            data-testid={`framework-card-${i + 1}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-6% 0px" }}
            transition={{ duration: 0.8, delay: (i % 4) * 0.1, ease: EASE }}
            whileHover={{ y: -6 }}
            className="group flex flex-col border border-[#08162B]/12 border-t-2 border-t-[#08162B] bg-white p-7 sm:p-8 shadow-[0_10px_40px_-20px_rgba(8,22,43,0.25)] hover:shadow-[0_30px_60px_-25px_rgba(8,22,43,0.35)] transition-shadow duration-500"
          >
            <p className="font-mono text-[10px] tracking-[0.3em] text-[#5A6E85]">
              {String(i + 1).padStart(2, "0")}
            </p>
            <h3 className="mt-4 font-condensed text-xl sm:text-2xl leading-snug text-[#08162B]">
              {fw.name}
            </h3>
            <p className="mt-4 text-base leading-relaxed text-[#5A6E85] flex-1">{fw.explanation}</p>
            <p className="mt-6 border-l-2 border-[#D4AF37] pl-3 font-mono text-[11px] uppercase tracking-[0.15em] leading-relaxed text-[#08162B]">
              {fw.takeaway}
            </p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default Frameworks;
